import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const GlobalExpansion = () => {
    const [openFaq, setOpenFaq] = useState(0);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const faqs = [
        {
            q: 'Which companies are ready for Global Expansion?',
            a: 'Global Expansion is designed for startups with proven value in their home market, a clear international objective and the capacity to act on local evidence. You do not need to have completed your market-entry plan, but you should know why expansion matters and what outcome you want to achieve.'
        },
        {
            q: 'Can Markoknow guarantee market-entry success?',
            a: 'No. Market entry depends on product fit, demand, pricing, regulation, competition and the company’s ability to execute. Markoknow helps reduce uncertainty through research, local validation, relevant introductions and milestone-based execution, but cannot guarantee commercial results.'
        },
        {
            q: 'Do you provide legal or tax advice?',
            a: 'Markoknow does not directly provide legal, tax or regulatory advice. Where required, we can help identify relevant independent professionals in the target market. Any formal advice or engagement remains between your company and the selected professional.'
        },
        {
            q: 'Which countries are currently supported?',
            a: 'Support depends on the company, industry and availability of relevant local operators. Our initial network focuses on India, Singapore, the UAE, the United Kingdom and selected markets across Southeast Asia, Europe and North America. Submit your target market, and we will confirm whether suitable support is available.'
        }
    ];

    return (
        <div className="ge-page">
            {/* =========================================================================
          SECTION 1: HERO (Global Expansion)
          ========================================================================= */}
            <section className="ge-hero-section">
                <div className="ge-hero-left">
                    <div className="ge-tag">GLOBAL EXPANSION</div>
                    <h1 className="ge-hero-title">
                        Enter new markets<br />
                        with local context<br />
                        and clear execution.
                    </h1>
                    <p className="ge-hero-desc">
                        From market selection to first partnerships, build a practical expansion path with operators who understand the ground.
                    </p>
                    <div className="ge-hero-actions">
                        <Link to="/globalexpansionform" style={{ textDecoration: 'none' }}>
                            <button className="ge-btn-primary">Build your market plan</button>
                        </Link>
                        <button className="ge-btn-outline">Explore expansion support</button>
                    </div>
                    <div className="ge-badge-check">
                        <span className="ge-chk-dot">✓</span>
                        <span>Strategy, introductions and execution—adapted to each market.</span>
                    </div>
                </div>

                <div className="ge-hero-right">
                    <div className="ge-map-graphic">
                        {/* World Map Background & Nodes */}
                        <svg className="ge-world-map-svg" viewBox="0 0 500 280" fill="none">
                            <path d="M70,80 Q100,50 140,70 T200,90 T240,60 T320,70 T400,60 T460,90 T430,160 T350,180 T260,170 T180,190 T100,160 Z" fill="#f0edfd" opacity="0.6" />
                            <path d="M120,95 Q240,30 360,75" stroke="#7c65c1" strokeWidth="1.5" strokeDasharray="3 3" fill="none" />
                            <path d="M360,75 Q380,130 400,145" stroke="#7c65c1" strokeWidth="1.5" strokeDasharray="3 3" fill="none" />
                            <path d="M360,75 Q310,120 330,140" stroke="#7c65c1" strokeWidth="1.5" fill="none" />
                        </svg>

                        {/* City Pins */}
                        <div className="ge-city-pin pin-ny">
                            <div className="ge-pulse-ring"></div>
                            <div className="ge-pin-core"></div>
                            <span>New York</span>
                        </div>
                        <div className="ge-city-pin pin-london">
                            <div className="ge-pulse-ring"></div>
                            <div className="ge-pin-core"></div>
                            <span>London</span>
                        </div>
                        <div className="ge-city-pin pin-dubai">
                            <div className="ge-pulse-ring"></div>
                            <div className="ge-pin-core"></div>
                            <span>Dubai</span>
                        </div>
                        <div className="ge-city-pin pin-india">
                            <div className="ge-pulse-ring"></div>
                            <div className="ge-pin-core"></div>
                            <span>India</span>
                        </div>
                        <div className="ge-city-pin pin-sg">
                            <div className="ge-pulse-ring"></div>
                            <div className="ge-pin-core"></div>
                            <span>Singapore</span>
                        </div>

                        {/* Expansion Command Center Floating Card */}
                        <div className="ge-command-card">
                            <h4>Expansion Command Center</h4>
                            <div className="ge-cc-row">
                                <span className="ge-cc-icon">🌐</span>
                                <div>
                                    <strong>Priority market</strong> · Singapore
                                </div>
                            </div>
                            <div className="ge-cc-progress-row">
                                <div className="ge-cc-readiness">
                                    <span>⏱️ Readiness · 78%</span>
                                </div>
                                <div className="ge-progress-track">
                                    <div className="ge-progress-fill" style={{ width: '78%' }}></div>
                                </div>
                            </div>
                            <div className="ge-cc-row">
                                <span className="ge-cc-icon">👥</span>
                                <div>Local partners · <strong>12 shortlisted</strong></div>
                            </div>
                            <div className="ge-cc-row">
                                <span className="ge-cc-icon">📑</span>
                                <div>Next milestone · <strong>Regulatory review</strong></div>
                            </div>
                        </div>

                        {/* Micro Floating Badges */}
                        <div className="ge-mini-badge badge-signal">
                            <span>📊</span>
                            <div>
                                <strong>Market signal</strong>
                                <p>High B2B demand</p>
                            </div>
                        </div>
                        <div className="ge-mini-badge badge-operator">
                            <span>👤</span>
                            <div>
                                <strong>Local operator</strong>
                                <p>Match available</p>
                            </div>
                        </div>
                        <div className="ge-mini-badge badge-timeline">
                            <span>⏱️</span>
                            <div>
                                <strong>Entry timeline</strong>
                                <p>12–16 weeks</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Hero Strip */}
            <div className="ge-hero-strip">
                <div className="ge-strip-col">
                    <span className="ge-strip-icon">📊</span>
                    <span>Market intelligence</span>
                </div>
                <div className="ge-strip-col">
                    <span className="ge-strip-icon">👥</span>
                    <span>Local operator access</span>
                </div>
                <div className="ge-strip-col">
                    <span className="ge-strip-icon">🤝</span>
                    <span>Partnership development</span>
                </div>
                <div className="ge-strip-col">
                    <span className="ge-strip-icon">🚀</span>
                    <span>Launch readiness</span>
                </div>
            </div>

            {/* Hero Sub-section: What We Help You Do */}
            <div className="ge-help-section">
                <div className="ge-tag">WHAT WE HELP YOU DO</div>
                <h2 className="ge-sec-title-sm">Turn a country decision into an operating plan.</h2>
                <div className="ge-help-grid">
                    <div className="ge-help-card">
                        <div className="ge-hc-icon">🎯</div>
                        <h4>Choose the right market</h4>
                        <p>Compare demand, competition and entry friction.</p>
                    </div>
                    <div className="ge-help-card">
                        <div className="ge-hc-icon">💬</div>
                        <h4>Build local context</h4>
                        <p>Learn from operators, customers and partners.</p>
                    </div>
                    <div className="ge-help-card">
                        <div className="ge-hc-icon">🛡️</div>
                        <h4>Prepare the entry</h4>
                        <p>Align structure, compliance and commercial motion.</p>
                    </div>
                    <div className="ge-help-card">
                        <div className="ge-hc-icon">📈</div>
                        <h4>Launch with momentum</h4>
                        <p>Convert introductions into first-market progress.</p>
                    </div>
                </div>
            </div>

            {/* =========================================================================
          SECTION 2: MARKET INTELLIGENCE (Scorecard Comparison Table)
          ========================================================================= */}
            <section className="ge-section ge-intel-section">
                <div className="ge-intel-header">
                    <div className="ge-ih-left">
                        <div className="ge-tag">MARKET INTELLIGENCE</div>
                        <h2 className="ge-sec-title">
                            Compare the opportunity before<br />
                            committing to the geography.
                        </h2>
                        <p className="ge-sec-desc">
                            A market can look attractive from a distance and still be wrong for your model. We combine structured research with conversations on the ground.
                        </p>
                        <button className="ge-btn-outline-dark">Explore the market scorecard</button>
                    </div>

                    <div className="ge-ih-right">
                        <div className="ge-radar-fit-graphic">
                            <div className="ge-fit-center-node">
                                🌐
                                <span>Market fit</span>
                            </div>
                            <div className="ge-rf-prop prop-top">📊 Demand</div>
                            <div className="ge-rf-prop prop-right">🚪 Access</div>
                            <div className="ge-rf-prop prop-bottom">🪙 Economics</div>
                            <div className="ge-rf-prop prop-left">⚠️ Friction</div>
                        </div>
                    </div>
                </div>

                {/* Candidate Market Comparison Table */}
                <div className="ge-table-card">
                    <div className="ge-table-head">
                        <h3>Candidate market comparison</h3>
                        <span className="ge-pill-sub">B2B SaaS · Growth stage</span>
                    </div>

                    <div className="ge-table-matrix">
                        {/* Headers */}
                        <div className="ge-matrix-row ge-matrix-head">
                            <div className="ge-col-metric">Metric</div>
                            <div className="ge-col-market col-active">
                                Singapore <span className="ge-priority-pill">Priority</span>
                            </div>
                            <div className="ge-col-market">UAE</div>
                            <div className="ge-col-market">United Kingdom</div>
                        </div>

                        {/* Row 1 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">📊 Demand signal</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot green"></span> Strong
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '85%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot green"></span> Strong
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '80%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Moderate
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '60%' }}></div></div>
                            </div>
                        </div>

                        {/* Row 2 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">👤 Buyer access</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot green"></span> High
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '90%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot green"></span> High
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '85%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Medium
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '55%' }}></div></div>
                            </div>
                        </div>

                        {/* Row 3 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">👥 Competition</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot amber"></span> High
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '75%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Medium
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '50%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> High
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '80%' }}></div></div>
                            </div>
                        </div>

                        {/* Row 4 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">⚖️ Regulatory friction</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot green"></span> Low
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '30%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Medium
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '50%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Medium
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '55%' }}></div></div>
                            </div>
                        </div>

                        {/* Row 5 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">🤝 Partner availability</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot green"></span> Strong
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '85%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot green"></span> Strong
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '80%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Moderate
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '60%' }}></div></div>
                            </div>
                        </div>

                        {/* Row 6 */}
                        <div className="ge-matrix-row">
                            <div className="ge-col-metric">🪙 Entry economics</div>
                            <div className="ge-col-market col-active">
                                <span className="ge-status-dot green"></span> Favourable
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '90%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot green"></span> Favourable
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '85%' }}></div></div>
                            </div>
                            <div className="ge-col-market">
                                <span className="ge-status-dot amber"></span> Selective
                                <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '65%' }}></div></div>
                            </div>
                        </div>

                        {/* Overall Score */}
                        <div className="ge-matrix-row ge-score-row">
                            <div className="ge-col-metric">◎ Overall fit</div>
                            <div className="ge-col-market col-active ge-score-val">86%</div>
                            <div className="ge-col-market ge-score-val">78%</div>
                            <div className="ge-col-market ge-score-val">69%</div>
                        </div>
                    </div>

                    {/* Table Callout Footer */}
                    <div className="ge-table-footer-callout">
                        <div className="ge-tfc-left">
                            <span className="ge-tfc-sparkle">✦</span>
                            <div>
                                <strong>Why Singapore leads</strong>
                                <p>Strong enterprise demand, regional access and partner density offset a competitive buyer environment.</p>
                            </div>
                        </div>
                        <a href="#market-brief" className="ge-tfc-link">Open market brief →</a>
                    </div>
                </div>

                {/* 4 Bottom Value Props */}
                <div className="ge-four-intel-grid">
                    <div className="ge-fi-item">
                        <div className="ge-fi-icon">🔍</div>
                        <div>
                            <h4>Demand validation</h4>
                            <p>Buyer interviews, category signals and pricing tests.</p>
                        </div>
                    </div>
                    <div className="ge-fi-item">
                        <div className="ge-fi-icon">👥</div>
                        <div>
                            <h4>Competitive landscape</h4>
                            <p>Incumbents, substitutes and positioning whitespace.</p>
                        </div>
                    </div>
                    <div className="ge-fi-item">
                        <div className="ge-fi-icon">📑</div>
                        <div>
                            <h4>Entry friction</h4>
                            <p>Regulation, setup complexity and operating constraints.</p>
                        </div>
                    </div>
                    <div className="ge-fi-item">
                        <div className="ge-fi-icon">🌐</div>
                        <div>
                            <h4>Partner ecosystem</h4>
                            <p>Channels, operators and relationships that accelerate access.</p>
                        </div>
                    </div>
                </div>

                <div className="ge-banner-bar-dark">
                    <span>✓</span> Research narrows the question. Local evidence improves the decision.
                </div>
            </section>

            {/* =========================================================================
          SECTION 3: LOCAL OPERATOR NETWORK (Dark Section)
          ========================================================================= */}
            <section className="ge-dark-section">
                <div className="ge-dark-split">
                    <div className="ge-dark-text-side">
                        <div className="ge-tag text-purple-light">LOCAL OPERATOR NETWORK</div>
                        <h2 className="ge-dark-h2">
                            Local access<br />
                            should begin with<br />
                            relevant people.
                        </h2>
                        <p className="ge-dark-p">
                            Work with vetted operators and ecosystem specialists who understand buyers, partnerships, regulation and execution inside the market.
                        </p>

                        <ul className="ge-dark-checklist">
                            <li><span className="ge-chk-purple">✓</span> Matched to market and business model</li>
                            <li><span className="ge-chk-purple">✓</span> Clear scope before every introduction</li>
                            <li><span className="ge-chk-purple">✓</span> Founder-controlled engagement</li>
                        </ul>

                        <button className="ge-btn-purple">Explore operator access</button>
                    </div>

                    {/* Local Operator App Window */}
                    <div className="ge-dark-window-side">
                        <div className="ge-operator-app">
                            <div className="ge-oa-header">
                                <strong>Singapore · Local Network</strong>
                                <span className="ge-oa-status">● 24 vetted connections</span>
                            </div>

                            <div className="ge-oa-body">
                                {/* Nav */}
                                <div className="ge-oa-nav">
                                    <div className="ge-oa-nav-item">🏠 Overview</div>
                                    <div className="ge-oa-nav-item active">👥 Operators</div>
                                    <div className="ge-oa-nav-item">💼 Partners</div>
                                    <div className="ge-oa-nav-item">🚀 Introductions</div>
                                </div>

                                {/* Operator Profiles */}
                                <div className="ge-oa-content">
                                    <h5>Recommended for your entry plan</h5>
                                    <div className="ge-operator-cards-row">
                                        {/* Op 1 */}
                                        <div className="ge-op-card">
                                            <span className="ge-op-fit">94% fit</span>
                                            <div className="ge-op-avatar">👩‍💼</div>
                                            <strong>Maya Tan</strong>
                                            <p className="ge-op-role">Enterprise GTM Operator</p>
                                            <div className="ge-op-tags">
                                                <span>B2B SaaS</span>
                                                <span>Singapore</span>
                                                <span>Buyer access</span>
                                            </div>
                                            <button className="ge-btn-op-profile">View profile</button>
                                        </div>

                                        {/* Op 2 */}
                                        <div className="ge-op-card">
                                            <span className="ge-op-fit">89% fit</span>
                                            <div className="ge-op-avatar">👨‍💼</div>
                                            <strong>Daniel Koh</strong>
                                            <p className="ge-op-role">Channel Partnerships</p>
                                            <div className="ge-op-tags">
                                                <span>Regional sales</span>
                                                <span>SEA</span>
                                                <span>Partnerships</span>
                                            </div>
                                            <button className="ge-btn-op-profile">View profile</button>
                                        </div>

                                        {/* Op 3 */}
                                        <div className="ge-op-card">
                                            <span className="ge-op-fit">87% fit</span>
                                            <div className="ge-op-avatar">👩‍💻</div>
                                            <strong>Adrina M.</strong>
                                            <p className="ge-op-role">Regulatory & Setup Advisor</p>
                                            <div className="ge-op-tags">
                                                <span>Entity setup</span>
                                                <span>Compliance</span>
                                                <span>Fintech</span>
                                            </div>
                                            <button className="ge-btn-op-profile">View profile</button>
                                        </div>
                                    </div>

                                    {/* Intro In Progress Status Widget */}
                                    <div className="ge-intro-progress-card">
                                        <div className="ge-ipc-left">
                                            <span className="ge-ipc-icon">🚀</span>
                                            <div>
                                                <strong>Introduction in progress</strong>
                                                <p>Maya is reviewing your enterprise buyer brief.</p>
                                            </div>
                                        </div>
                                        <div className="ge-ipc-steps">
                                            <span className="ge-ipc-dot active">✓ Brief shared</span>
                                            <span className="ge-ipc-line"></span>
                                            <span className="ge-ipc-dot active">✓ Context accepted</span>
                                            <span className="ge-ipc-line"></span>
                                            <span className="ge-ipc-dot">○ Meeting proposed</span>
                                        </div>
                                        <button className="ge-btn-view-intro">View introduction</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 4 Bottom Value Props */}
                <div className="ge-dark-four-grid">
                    <div className="ge-d4-card">
                        <div className="ge-d4-icon">💬</div>
                        <div>
                            <h4>Operator insight</h4>
                            <p>Learn what only practitioners can explain.</p>
                        </div>
                    </div>
                    <div className="ge-d4-card">
                        <div className="ge-d4-icon">👥</div>
                        <div>
                            <h4>Partner pathways</h4>
                            <p>Find channels and collaborators with real relevance.</p>
                        </div>
                    </div>
                    <div className="ge-d4-card">
                        <div className="ge-d4-icon">🤝</div>
                        <div>
                            <h4>Buyer access</h4>
                            <p>Reach qualified conversations through trusted context.</p>
                        </div>
                    </div>
                    <div className="ge-d4-card">
                        <div className="ge-d4-icon">🎯</div>
                        <div>
                            <h4>Execution support</h4>
                            <p>Translate decisions into local action.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================================================
          SECTION 4: THE EXPANSION PATH (5-Step Timeline + 16-Week Sprint)
          ========================================================================= */}
            <section className="ge-section ge-path-section">
                <div className="ge-sec-header text-center">
                    <div className="ge-tag centered-tag">THE EXPANSION PATH</div>
                    <h2 className="ge-sec-title">Move from market interest to market evidence.</h2>
                    <p className="ge-sec-desc">
                        A staged process helps you test assumptions early, commit resources deliberately and build momentum around real commercial signals.
                    </p>
                </div>

                {/* 5 Steps Horizontal */}
                <div className="ge-steps-timeline">
                    <div className="ge-timeline-line-5"></div>
                    <div className="ge-steps-5-grid">
                        <div className="ge-step5-card">
                            <div className="ge-step5-num">01</div>
                            <h4>Market thesis</h4>
                            <p>Define why this market, which customer and what advantage travels.</p>
                            <div className="ge-step5-icon-box">🧭</div>
                            <span className="ge-step5-tag">Direction</span>
                        </div>

                        <div className="ge-step5-card">
                            <div className="ge-step5-num">02</div>
                            <h4>Ground validation</h4>
                            <p>Test demand, pricing, competition and buyer behaviour with local evidence.</p>
                            <div className="ge-step5-icon-box">📍</div>
                            <span className="ge-step5-tag">Evidence</span>
                        </div>

                        <div className="ge-step5-card">
                            <div className="ge-step5-num">03</div>
                            <h4>Entry design</h4>
                            <p>Choose the right structure, partner model, team and commercial motion.</p>
                            <div className="ge-step5-icon-box">📐</div>
                            <span className="ge-step5-tag">Plan</span>
                        </div>

                        <div className="ge-step5-card">
                            <div className="ge-step5-num">04</div>
                            <h4>Local activation</h4>
                            <p>Build operator access, partnerships, early pipeline and launch readiness.</p>
                            <div className="ge-step5-icon-box">🤝</div>
                            <span className="ge-step5-tag">Execution</span>
                        </div>

                        <div className="ge-step5-card">
                            <div className="ge-step5-num">05</div>
                            <h4>First traction</h4>
                            <p>Turn conversations into pilots, revenue and a repeatable market rhythm.</p>
                            <div className="ge-step5-icon-box">📈</div>
                            <span className="ge-step5-tag">Momentum</span>
                        </div>
                    </div>
                </div>

                {/* 16-Week Market-Entry Sprint Widget */}
                <div className="ge-sprint-container">
                    <div className="ge-sprint-left">
                        <h3>A 16-week market-entry sprint</h3>
                        <div className="ge-sprint-timeline">
                            <div className="ge-sprint-step">
                                <div className="ge-ss-icon">📊</div>
                                <div className="ge-ss-line"></div>
                                <strong>Weeks 1–3 · Diagnose</strong>
                                <p>Market thesis and readiness baseline</p>
                            </div>

                            <div className="ge-sprint-step">
                                <div className="ge-ss-icon">👥</div>
                                <div className="ge-ss-line"></div>
                                <strong>Weeks 4–7 · Validate</strong>
                                <p>Local interviews and commercial testing</p>
                            </div>

                            <div className="ge-sprint-step">
                                <div className="ge-ss-icon">📐</div>
                                <div className="ge-ss-line"></div>
                                <strong>Weeks 8–11 · Design</strong>
                                <p>Entry model and partner pathway</p>
                            </div>

                            <div className="ge-sprint-step">
                                <div className="ge-ss-icon">🚀</div>
                                <div className="ge-ss-line"></div>
                                <strong>Weeks 12–16 · Activate</strong>
                                <p>Introductions, pipeline and launch milestones</p>
                            </div>
                        </div>
                    </div>

                    <div className="ge-sprint-right">
                        <div className="ge-readiness-box">
                            <h4>Expansion readiness</h4>
                            <div className="ge-rb-row">
                                <span>🌐 Market demand</span>
                                <span className="ge-badge-green">Strong</span>
                            </div>
                            <div className="ge-rb-row">
                                <span>⏱️ Commercial fit · 74%</span>
                            </div>
                            <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '74%' }}></div></div>

                            <div className="ge-rb-row">
                                <span>👥 Local network</span>
                                <span className="ge-badge-blue">Building</span>
                            </div>
                            <div className="ge-rb-row">
                                <span>📑 Operational readiness · 68%</span>
                            </div>
                            <div className="ge-mini-bar"><div className="ge-bar-fill" style={{ width: '68%' }}></div></div>

                            <button className="ge-btn-outline-purple">View readiness framework</button>
                        </div>
                    </div>
                </div>

                <div className="ge-sprint-bottom-strip">
                    <div>✓ Evidence before investment</div>
                    <div className="ge-sbs-sep"></div>
                    <div>✓ Local context before commitment</div>
                    <div className="ge-sbs-sep"></div>
                    <div>✓ Milestones before scale</div>
                </div>
            </section>

            {/* =========================================================================
          SECTION 5: TRUST BY DESIGN (Agreement & Fit Rules)
          ========================================================================= */}
            <section className="ge-section ge-trust-section">
                <div className="ge-trust-header">
                    <div className="ge-th-left">
                        <div className="ge-tag">TRUST BY DESIGN</div>
                        <h2 className="ge-sec-title">
                            Honest conversations need<br />
                            more than good intentions.
                        </h2>
                        <p className="ge-sec-desc">
                            Every circle is protected by deliberate matching, clear participation rules and skilled facilitation—so founders can discuss what is actually difficult.
                        </p>
                    </div>

                    <div className="ge-th-right">
                        <div className="ge-shield-orbit">
                            <div className="ge-shield-center">
                                🛡️
                                <span>Private by default</span>
                            </div>
                            <div className="ge-so-avatar o-1">👨‍💼</div>
                            <div className="ge-so-avatar o-2">👩‍💼</div>
                            <div className="ge-so-avatar o-3">👨‍💻</div>
                            <div className="ge-so-avatar o-4">👩‍🔬</div>
                            <div className="ge-so-avatar o-5">👨‍🎨</div>
                            <div className="ge-so-avatar o-6">👩‍💻</div>
                        </div>
                    </div>
                </div>

                {/* 4 Pillars */}
                <div className="ge-pillars-grid">
                    <div className="ge-pillar-card">
                        <span className="ge-pillar-num">01</span>
                        <div className="ge-pillar-icon">🔄</div>
                        <h4>Conflict-aware matching</h4>
                        <p>We screen for direct competition, sensitive overlap and obvious commercial conflicts.</p>
                    </div>
                    <div className="ge-pillar-card">
                        <span className="ge-pillar-num">02</span>
                        <div className="ge-pillar-icon">🔒</div>
                        <h4>Confidentiality commitment</h4>
                        <p>What is shared inside a circle stays inside the circle.</p>
                    </div>
                    <div className="ge-pillar-card">
                        <span className="ge-pillar-num">03</span>
                        <div className="ge-pillar-icon">🧭</div>
                        <h4>Structured facilitation</h4>
                        <p>A trained facilitator protects time, depth and balanced participation.</p>
                    </div>
                    <div className="ge-pillar-card">
                        <span className="ge-pillar-num">04</span>
                        <div className="ge-pillar-icon">🤝</div>
                        <h4>Founder-first conduct</h4>
                        <p>No selling, recruiting pressure, fundraising pitches or performative updates.</p>
                    </div>
                </div>

                {/* The Circle Agreement vs Not Right Fit */}
                <div className="ge-rules-split">
                    <div className="ge-agreement-card">
                        <h4>The circle agreement</h4>
                        <ul>
                            <li><span className="ge-chk-blue">✓</span> Speak from direct experience</li>
                            <li><span className="ge-chk-blue">✓</span> Ask before giving advice</li>
                            <li><span className="ge-chk-blue">✓</span> Protect member confidentiality</li>
                            <li><span className="ge-chk-blue">✓</span> Declare relevant conflicts</li>
                            <li><span className="ge-chk-blue">✓</span> Follow through on commitments</li>
                        </ul>
                        <button className="ge-btn-principles">Read the circle principles</button>
                    </div>

                    <div className="ge-not-fit-card">
                        <h4>When a circle is not the right fit</h4>
                        <ul>
                            <li><span className="ge-minus-circle">−</span> You want an audience for a pitch</li>
                            <li><span className="ge-minus-circle">−</span> You need transactional networking</li>
                            <li><span className="ge-minus-circle">−</span> You cannot attend consistently</li>
                            <li><span className="ge-minus-circle">−</span> You are unwilling to discuss real challenges</li>
                        </ul>
                        <p className="ge-not-fit-note">
                            The strongest circles are built on contribution, candour and continuity.
                        </p>
                    </div>
                </div>

                {/* 4 Bottom Badges */}
                <div className="ge-trust-bottom-bar">
                    <div>👥 Small by design</div>
                    <div className="ge-tbb-sep"></div>
                    <div>🛡️ Screened for conflicts</div>
                    <div className="ge-tbb-sep"></div>
                    <div>🧭 Facilitated with care</div>
                    <div className="ge-tbb-sep"></div>
                    <div>🔒 Protected by commitment</div>
                </div>
            </section>

            {/* =========================================================================
          SECTION 6: CHOOSE STARTING POINT & FAQ & CTA BANNER
          ========================================================================= */}
            <section className="ge-section ge-start-point-section" id="start-plan">
                <div className="ge-start-split">
                    {/* Left 3 Engagement Tier Options */}
                    <div className="ge-start-left">
                        <div className="ge-tag">CHOOSE YOUR STARTING POINT</div>
                        <h2 className="ge-sec-title">
                            Start with the decision<br />
                            your expansion needs now.
                        </h2>
                        <p className="ge-sec-desc">
                            Engagements are shaped around your stage of readiness—from an initial market decision to a structured launch.
                        </p>

                        <div className="ge-plans-grid">
                            {/* Plan 1 */}
                            <div className="ge-plan-card">
                                <div className="ge-pc-icon">📊</div>
                                <h4>Market Assessment</h4>
                                <p className="ge-pc-sub">For choosing where to enter</p>
                                <p className="ge-pc-detail">Comparative scorecard · Local interviews · Entry recommendation</p>
                                <div className="ge-pc-footer">
                                    <span className="ge-pc-time">⏱️ 2–4 weeks</span>
                                </div>
                            </div>

                            {/* Plan 2 (Highlighted) */}
                            <div className="ge-plan-card highlighted-plan">
                                <div className="ge-featured-badge">Most comprehensive</div>
                                <div className="ge-pc-icon">🚀</div>
                                <h4>Entry Sprint</h4>
                                <p className="ge-pc-sub">For preparing and activating</p>
                                <p className="ge-pc-detail">16-week roadmap · Operator access · Partner development</p>
                                <div className="ge-pc-footer">
                                    <span className="ge-pc-time">⏱️ 12–16 weeks</span>
                                </div>
                            </div>

                            {/* Plan 3 */}
                            <div className="ge-plan-card">
                                <div className="ge-pc-icon">👥</div>
                                <h4>Local Activation</h4>
                                <p className="ge-pc-sub">For companies already committed</p>
                                <p className="ge-pc-detail">Targeted introductions · Pipeline building · Execution support</p>
                                <div className="ge-pc-footer">
                                    <span className="ge-pc-time">⏱️ Custom</span>
                                </div>
                            </div>
                        </div>

                        <div className="ge-scope-note">
                            🛡️ Scope and commercial terms are agreed before work begins.
                        </div>
                    </div>

                    {/* Right FAQ List */}
                    <div className="ge-start-right">
                        <h3>Frequently asked questions</h3>
                        <div className="ge-faq-list">
                            {faqs.map((faq, index) => (
                                <div
                                    key={index}
                                    className={`ge-faq-card ${openFaq === index ? 'active' : ''}`}
                                    onClick={() => toggleFaq(index)}
                                >
                                    <div className="ge-faq-head">
                                        <span className="ge-faq-q">{faq.q}</span>
                                        <span className="ge-faq-toggle">{openFaq === index ? '−' : '+'}</span>
                                    </div>
                                    {openFaq === index && <p className="ge-faq-a">{faq.a}</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom Blue CTA Banner */}
                <div className="ge-bottom-cta-banner">
                    <div className="ge-cta-left">
                        <span className="ge-cta-tag">PLAN YOUR NEXT MARKET</span>
                        <h3 className="ge-cta-h3">
                            Build the evidence, access and operating path for expansion.
                        </h3>
                        <p className="ge-cta-p">
                            Tell us where you are considering, why the market matters and what progress should look like.
                        </p>
                        <div className="ge-cta-btns">
                            <button className="ge-btn-white">Plan your expansion</button>
                            <button className="ge-btn-trans">Share your target market</button>
                        </div>
                    </div>

                    <div className="ge-cta-right">
                        <div className="ge-card-checklist-box">
                            <h4>Before we begin</h4>
                            <ul>
                                <li><span className="ge-chk-blue">✓</span> Home-market traction</li>
                                <li><span className="ge-chk-blue">✓</span> Defined expansion goal</li>
                                <li><span className="ge-chk-blue">✓</span> Executive ownership</li>
                                <li><span className="ge-chk-blue">✓</span> Capacity to execute</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GlobalExpansion;